import { showSuccessToast, showErrorToast } from '../../../shared/utils/toastManager';

import {
  SET_NEW_VT_DASH,
  FETCH_VT_TEMPLATES_START,
  FETCH_VT_TEMPLATES_FULFILLED,
  FETCH_VT_TEMPLATES_REJECTED,
  SET_ACTIVE_VT_DASH,
  CLEAR_ACTIVE_VT_DASH,
  FETCH_EXERCISES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_GROUPS_START,
  FETCH_GROUPS_FULFILLED,
  FETCH_GROUPS_REJECTED,
  FETCH_VT_DASH_DATA_START,
  FETCH_VT_DASH_DATA_FULFILLED,
  FETCH_VT_DASH_DATA_REJECTED,
  SET_SELECTED_START_DATE,
  SET_START_DATE_DATA,
  SET_SELECTED_END_DATE,
  SET_END_DATE_DATA,
  SET_EXERCISES,
  SET_BUCKET_SIZE,
  SET_OVERVIEW_RANGE_MAX,
  SET_OVERVIEW_RANGE_MIN,
  SET_ASSIGNED_COMPLETED_RANGE_MAX,
  SET_ASSIGNED_COMPLETED_RANGE_MIN,
  SET_NEXT_LOCATION,
  SET_IS_VT_DASH_DISPLAYED,
  SET_VT_DASH_VIEW,
  SET_GROUP,
  SET_GROUPS,
  FETCH_ATHLETES_FROM_GROUP_START,
  FETCH_ATHLETES_FROM_GROUP_FULFILLED,
  FETCH_ATHLETES_FROM_GROUP_REJECTED,
  SET_SELECTED_ATHLETE,
  SET_IS_EXERCISE_FILTERS_SHOWING,
  SET_EXERCISE_FILTERS,
  SET_UNSAVED_VT_DASH_MODAL,
  SET_SAVE_VT_DASH_MODAL,
  CREATE_VT_TEMPLATE_START,
  CREATE_VT_TEMPLATE_FULFILLED,
  CREATE_VT_TEMPLATE_REJECTED,
  SET_ABOUT_VT_DASH_MODAL,
  FETCH_PUBLIC_VT_DASH_DATA_START,
  FETCH_PUBLIC_VT_DASH_DATA_FULFILLED,
  FETCH_PUBLIC_VT_DASH_DATA_REJECTED,
  SET_DUPLICATE_VT_DASH_MODAL,
  DUPLICATE_VT_TEMPLATE_START,
  DUPLICATE_VT_TEMPLATE_FULFILLED,
  DUPLICATE_VT_TEMPLATE_REJECTED,
  SET_EDIT_VT_DASH_MODAL,
  EDIT_VT_TEMPLATE_START,
  EDIT_VT_TEMPLATE_FULFILLED,
  EDIT_VT_TEMPLATE_REJECTED,
  SET_DELETE_VT_DASH_MODAL,
  DELETE_VT_TEMPLATE_START,
  DELETE_VT_TEMPLATE_FULFILLED,
  DELETE_VT_TEMPLATE_REJECTED,
  CLEAR_SHARE_VT_DASH_LINK,
  SET_SHARE_VT_DASH_MODAL,
  FETCH_SHARE_VT_DASH_LINK_START,
  FETCH_SHARE_VT_DASH_LINK_FULFILLED,
  FETCH_SHARE_VT_DASH_LINK_REJECTED,
  SET_OPTION_VT_DASH_MODAL,
  SET_ONBOARDING_MODAL,
  CLEAR_VT_DASH_DATA,
  CLEAR_VT_DASH_MODALS,
} from './actionTypes';

import {
  axiosAuthed,
  axiosUnauthed,
} from '../../../shared/utils/setCommonHeaders';

export const setIsNewVTDash = (bool) => ({
  type: SET_NEW_VT_DASH,
  payload: bool,
});

export const fetchVTTemplates = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_VT_TEMPLATES_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/reports/volume-tracker/templates`)
    .then((response) => {
      dispatch({
        type: FETCH_VT_TEMPLATES_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_VT_TEMPLATES_REJECTED,
        payload: err,
      });
    });
};

export const setActiveVTDash = (obj) => ({
  type: SET_ACTIVE_VT_DASH,
  payload: obj,
});

export const clearActiveVTDash = () => ({
  type: CLEAR_ACTIVE_VT_DASH,
});

export const fetchExercises = (accountCode) => (
  (dispatch) => {
    dispatch({ type: FETCH_EXERCISES_START });
    axiosAuthed.get(`/accounts/${accountCode}/exercises?tracked=1&type=L`)
      .then((response) => {
        dispatch({
          type: FETCH_EXERCISES_FULFILLED,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: FETCH_EXERCISES_REJECTED,
          payload: err,
        });
      });
  }
);

export const fetchGroups = (accountCode) => (
  (dispatch) => {
    dispatch({ type: FETCH_GROUPS_START });
    axiosAuthed.get(`/accounts/${accountCode}/groups?reporting=1`)
      .then((response) => {
        dispatch({
          payload: response.data,
          type: FETCH_GROUPS_FULFILLED,
        });
      })
      .catch((err) => {
        dispatch({
          payload: err,
          type: FETCH_GROUPS_REJECTED,
        });
      });
  }
);

export const fetchVTDashData = (
  accountCode,
  startDate,
  endDate,
  groupId,
  exerIds,
  bucketSize,
  rangeMax,
  rangeMin,
) => (
  (dispatch) => {
    dispatch({ type: FETCH_VT_DASH_DATA_START });
    axiosAuthed.get(
      `/accounts/${accountCode}/reports/volume-tracker?startDate=${startDate}&endDate=${endDate}&groupId=${groupId}&exerciseIds=${exerIds}&bucketSize=${bucketSize}&rangeMax=${rangeMax}&rangeMin=${rangeMin}`,
    )
      .then((response) => {
        dispatch({
          payload: {
            vtDashData: response.data,
          },
          type: FETCH_VT_DASH_DATA_FULFILLED,
        });
      })
      .catch((err) => {
        dispatch({
          payload: err,
          type: FETCH_VT_DASH_DATA_REJECTED,
        });
      });
  }
);

export const setSelectedStartDate = (date) => (dispatch) => {
  dispatch({
    payload: date,
    type: SET_SELECTED_START_DATE,
  });
};

export const setStartDateData = (startDate) => (
  (dispatch) => {
    dispatch({
      payload: startDate,
      type: SET_START_DATE_DATA,
    });
  }
);

export const setSelectedEndDate = (date) => (dispatch) => {
  dispatch({
    payload: date,
    type: SET_SELECTED_END_DATE,
  });
};

export const setEndDateData = (endDate) => (
  (dispatch) => {
    dispatch({
      payload: endDate,
      type: SET_END_DATE_DATA,
    });
  }
);

export const setExercises = (exercises) => (
  (dispatch) => {
    dispatch({
      payload: exercises,
      type: SET_EXERCISES,
    });
  }
);

export const setBucketSize = (bucketSize) => (
  (dispatch) => {
    dispatch({
      payload: bucketSize,
      type: SET_BUCKET_SIZE,
    });
  }
);

export const setOverviewRangeMax = (rangeMax) => (
  (dispatch) => {
    dispatch({
      payload: rangeMax,
      type: SET_OVERVIEW_RANGE_MAX,
    });
  }
);

export const setOverviewRangeMin = (rangeMin) => (
  (dispatch) => {
    dispatch({
      payload: rangeMin,
      type: SET_OVERVIEW_RANGE_MIN,
    });
  }
);

export const setAssignedCompletedRangeMax = (rangeMax) => (
  (dispatch) => {
    dispatch({
      payload: rangeMax,
      type: SET_ASSIGNED_COMPLETED_RANGE_MAX,
    });
  }
);

export const setAssignedCompletedRangeMin = (rangeMin) => (
  (dispatch) => {
    dispatch({
      payload: rangeMin,
      type: SET_ASSIGNED_COMPLETED_RANGE_MIN,
    });
  }
);

export const setNextLocation = (location) => (
  (dispatch) => {
    dispatch({
      payload: location,
      type: SET_NEXT_LOCATION,
    });
  }
);

export const setIsVTDashDisplayed = (bool) => (
  {
    type: SET_IS_VT_DASH_DISPLAYED,
    payload: bool,
  }
);

export const setVTDashView = (view) => (
  (dispatch) => {
    dispatch({
      payload: view,
      type: SET_VT_DASH_VIEW,
    });
  }
);

export const setGroup = (group) => (
  (dispatch) => {
    dispatch({
      payload: group,
      type: SET_GROUP,
    });
  }
);

export const setGroups = (groups) => (
  (dispatch) => {
    dispatch({
      payload: groups,
      type: SET_GROUPS,
    });
  }
);

export const fetchAthletesFromGroup = (accountCode, groupId) => (
  dispatch,
) => {
  dispatch({ type: FETCH_ATHLETES_FROM_GROUP_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/groups/${groupId}/user-detail`)
    .then((response) => {
      dispatch({
        payload: response.data,
        type: FETCH_ATHLETES_FROM_GROUP_FULFILLED,
      });
    })
    .catch((err) => {
      dispatch({
        payload: err,
        type: FETCH_ATHLETES_FROM_GROUP_REJECTED,
      });
    });
};

export const setSelectedAthlete = (athlete, bool) => (
  (dispatch) => {
    dispatch({
      payload: {
        athlete,
        bool,
      },
      type: SET_SELECTED_ATHLETE,
    });
  }
);

export const setIsExerciseFiltersShowing = (bool) => (
  (dispatch) => {
    dispatch({
      payload: bool,
      type: SET_IS_EXERCISE_FILTERS_SHOWING,
    });
  }
);

export const setExerciseFilters = (filters) => (
  (dispatch) => {
    dispatch({
      payload: filters,
      type: SET_EXERCISE_FILTERS,
    });
  }
);

export const setUnsavedVTDashModal = (bool) => (
  (dispatch) => {
    dispatch({
      payload: bool,
      type: SET_UNSAVED_VT_DASH_MODAL,
    });
  }
);

export const setSaveVTDashModal = (bool) => (dispatch) => {
  dispatch({
    type: SET_SAVE_VT_DASH_MODAL,
    payload: bool,
  });
};

export const createVTTemplate = (accountCode, submissionObject) => (
  dispatch,
) => {
  dispatch({ type: CREATE_VT_TEMPLATE_START });
  axiosAuthed
    .post(
      `/accounts/${accountCode}/reports/volume-tracker/templates`,
      submissionObject,
    )
    .then((response) => {
      showSuccessToast('Dashboard Created!');
      dispatch({
        type: CREATE_VT_TEMPLATE_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred');
      dispatch({
        type: CREATE_VT_TEMPLATE_REJECTED,
        payload: err,
      });
    });
};

export const setAboutVTDashModal = (bool, template = null) => ({
  type: SET_ABOUT_VT_DASH_MODAL,
  payload: {
    bool,
    template,
  },
});

export const fetchPublicVTDashData = (token) => (
  dispatch,
) => {
  dispatch({ type: FETCH_PUBLIC_VT_DASH_DATA_START });
  axiosUnauthed.get(`/public/reports/volume-tracker?token=${token}`)
    .then((response) => {
      dispatch({
        type: FETCH_PUBLIC_VT_DASH_DATA_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_PUBLIC_VT_DASH_DATA_REJECTED,
        payload: err?.response?.headers?.message,
      });
    });
};

export const setDuplicateVTDashModal = (bool, template = {}) => ({
  type: SET_DUPLICATE_VT_DASH_MODAL,
  payload: {
    bool,
    template,
  },
});

export const duplicateVTTemplate = (
  accountCode,
  templateId,
  submissionObject,
) => (dispatch) => {
  dispatch({ type: DUPLICATE_VT_TEMPLATE_START });
  axiosAuthed
    .post(
      `/accounts/${accountCode}/reports/volume-tracker/templates/${templateId}/duplicate`,
      submissionObject,
    )
    .then((response) => {
      showSuccessToast('Template Duplicated!');
      dispatch({
        type: DUPLICATE_VT_TEMPLATE_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred');
      dispatch({
        type: DUPLICATE_VT_TEMPLATE_REJECTED,
        payload: err,
      });
    });
};

export const setEditVTDashModal = (bool, template = {}) => ({
  type: SET_EDIT_VT_DASH_MODAL,
  payload: {
    bool,
    template,
  },
});

export const editVTTemplate = (
  accountCode,
  submissionObject,
  templateId,
  index,
) => (dispatch) => {
  dispatch({ type: EDIT_VT_TEMPLATE_START });
  axiosAuthed
    .put(
      `/accounts/${accountCode}/reports/volume-tracker/templates/${templateId}?resetGroups=false&resetMetrics=false`,
      submissionObject,
    )
    .then((response) => {
      showSuccessToast('Edit Successful!');
      dispatch({
        type: EDIT_VT_TEMPLATE_FULFILLED,
        payload: {
          data: response.data,
          index,
        },
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred');
      dispatch({
        type: EDIT_VT_TEMPLATE_REJECTED,
        payload: err,
      });
    });
};

export const setDeleteVTDashModal = (bool, template = {}) => ({
  type: SET_DELETE_VT_DASH_MODAL,
  payload: {
    bool,
    template,
  },
});

export const deleteVTTemplate = (accountCode, templateId, templateIndex) => (
  dispatch,
) => {
  dispatch({ type: DELETE_VT_TEMPLATE_START });
  axiosAuthed
    .delete(
      `/accounts/${accountCode}/reports/volume-tracker/templates/${templateId}`,
    )
    .then((response) => {
      showSuccessToast('Template Deleted!');
      dispatch({
        type: DELETE_VT_TEMPLATE_FULFILLED,
        payload: { data: response.data, index: templateIndex },
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred');
      dispatch({
        type: DELETE_VT_TEMPLATE_REJECTED,
        payload: err,
      });
    });
};

export const setShareVTDashModal = (bool, template = {}) => ({
  type: SET_SHARE_VT_DASH_MODAL,
  payload: {
    bool,
    template,
  },
});

export const fetchShareVTDashLink = (accountCode, submissionObj) => (
  dispatch,
) => {
  dispatch({ type: FETCH_SHARE_VT_DASH_LINK_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/reports/volume-tracker/link`, submissionObj)
    .then((response) => {
      dispatch({
        type: FETCH_SHARE_VT_DASH_LINK_FULFILLED,
        payload: response.data.url,
      });
    })
    .catch(() => {
      dispatch({
        type: FETCH_SHARE_VT_DASH_LINK_REJECTED,
        payload: true,
      });
    });
};

export const setOnboardingModal = (bool) => ({
  type: SET_ONBOARDING_MODAL,
  payload: bool,
});

export const setOptionVTDashModal = (bool) => ({
  type: SET_OPTION_VT_DASH_MODAL,
  payload: bool,
});

export const clearShareVTDashLink = () => ((dispatch) => {
  dispatch({
    type: CLEAR_SHARE_VT_DASH_LINK,
  });
});

export const clearVTDashData = () => ((dispatch) => {
  dispatch({
    type: CLEAR_VT_DASH_DATA,
  });
});

export const clearVTDashModals = () => ((dispatch) => {
  dispatch({
    type: CLEAR_VT_DASH_MODALS,
  });
});
